// Module
var code = `<div class="jumbotron-surface scenes-surface">
  <div class="jumbotron-panel-head">
    <span class="jumbotron-heading">Configure Scenes</span>
    <div class="scenes-actions">
      <button type="button" class="btn btn-sm btn-primary" ui-sref="manager.scene-new">
        <i class="fas fa-plus" aria-hidden="true"></i> Add scene
      </button>
    </div>
  </div>

  <div class="scenes-body">
    <ul class="scenes-list">
      <li class="scenes-row" ng-repeat="scene in \$ctrl.Scenes track by scene.id">
        <span class="scenes-row-main">
          <i class="fas fa-fw scenes-orientation" aria-hidden="true"
            ng-class="{'fa-arrows-up-down': scene.orientation === 'p', 'fa-arrows-left-right': scene.orientation === 'l'}"
            title="{{scene.orientation === 'p' ? 'Portrait' : 'Landscape'}}"></i>
          <!-- The colour of a scene is data, so the template sets it inline. -->
          <span class="scenes-name" ng-style="{'color': scene.color}">{{scene.name}}</span>
          <i class="fas fa-star scenes-here" aria-hidden="true" ng-if="\$ctrl.clientId === scene.clientId"
            title="This browser is the player of this scene"></i>
        </span>
        <button type="button" class="btn btn-sm btn-outline-primary" ui-sref="manager.scene-edit({id: scene.id})"
          aria-label="Edit scene {{scene.name}}" title="Edit scene">
          <i class="fas fa-pencil" aria-hidden="true"></i>
        </button>
      </li>
    </ul>

    <p class="scenes-client">
      <span class="jumbotron-note">The id of this browser. Click it to copy it.</span>
      <button type="button" class="jumbotron-chip scenes-client-id" ng-class="{'is-ok': \$ctrl.copySuccess}"
        ng-click="\$ctrl.copyToClipboard()" title="Copy the id" aria-label="Copy the id of this browser">
        {{\$ctrl.clientId}}
        <i class="fas" aria-hidden="true" ng-class="\$ctrl.copySuccess ? 'fa-check' : 'fa-clipboard'"></i>
      </button>
    </p>
  </div>
</div>
`;
// Exports
export default code;